<template>
  <div id="index">
    <div class="banner">
      <el-carousel trigger="click" height="800px">
        <el-carousel-item v-for="item in bannerList" :key="item.id">
          <img :src="item.picUrl" alt="" @click="tojunpUrl(item.junpUrl)" />
        </el-carousel-item>
      </el-carousel>
      <!-- 公告 -->
      <div class="notice fix" @click="noticeSpot">
        <div class="notice_fl fl">
          <div class="notice_fl_fl fl">
            <img
              v-if="weatherList[0].wea_img === 'bingbao'"
              src="@/assets/bingbao.png"
              alt=""
            />
            <img
              v-if="weatherList[0].wea_img === 'lei'"
              src="@/assets/lei.png"
              alt=""
            />
            <img
              v-if="weatherList[0].wea_img === 'qing'"
              src="@/assets/qing.png"
              alt=""
            />
            <img
              v-if="weatherList[0].wea_img === 'shachen'"
              src="@/assets/shachen.png"
              alt=""
            />
            <img
              v-if="weatherList[0].wea_img === 'wu'"
              src="@/assets/wu.png"
              alt=""
            />
            <img
              v-if="weatherList[0].wea_img === 'xue'"
              src="@/assets/xue.png"
              alt=""
            />
            <img
              v-if="weatherList[0].wea_img === 'yin'"
              src="@/assets/yin.png"
              alt=""
            />
            <img
              v-if="weatherList[0].wea_img === 'yu'"
              src="@/assets/yu.png"
              alt=""
            />
            <img
              v-if="weatherList[0].wea_img === 'yun'"
              src="@/assets/yun.png"
              alt=""
            />
          </div>
          <div class="notice_fl_fr fl">
            <p>{{ todayWeather.currentDate }}</p>
            <p>{{ todayWeather.wea }} {{ todayWeather.tem }}℃</p>
          </div>
        </div>
        <div class="notice_fr fr">
          <div class="notice_fr_fl fl">
            <img src="@/assets/in13.png" alt="" />
          </div>
          <div class="notice_fr_fr fl">
            <!-- <vue-seamless-scroll
              :data="notice"
              class="seamless-warp"
              :class-option="classOptions"
            >
              <ul class="fix">
                <li
                  v-for="(item, index) in notice"
                  :key="index"
                  class="fl"
                >
                  <div class="fl" v-html="item"></div>
                </li>
              </ul>
            </vue-seamless-scroll> -->
            <div class="animate" v-html="content"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="warp">
      <!-- 景区介绍 -->
      <div>
        <div class="comtit">
          <div class="comtit_t">公司介绍</div>
          <div class="comtit_f fix">
            <div class="comtit_f_fl fl">The company introduction</div>
            <div class="comtit_f_fr fr" @click="toIntroduce">MORE>></div>
          </div>
        </div>
        <div class="introduce">
          <div class="introduce_top" @click="toIntroduce">
            <img :src="companyInfo.companyImgUrl" alt="" />
            <div class="introduce_top_f">
              <div v-html="companyInfo.summary"></div>
            </div>
          </div>
          <div class="introduce_item fix">
            <swiper :options="swiperOption">
              <swiper-slide
                class="item_li"
                v-for="(item, index) in scenicList"
                :key="index"
              >
                <img
                  @click="tojdxq(item.scenicId)"
                  :src="item.scenicImgUrl"
                  alt=""
                />

                <div @click="tojdxq(item.scenicId)" class="item_li_nei">
                  <p>
                    {{ item.scenicName }}
                  </p>
                </div>
              </swiper-slide>
            </swiper>
          </div>
          <div class="introduce_gg" @click="toTickets">
            <img src="@/assets/in05.jpg" alt="" />
          </div>
        </div>
      </div>

      <!-- 游记攻略 -->
      <div>
        <div class="comtit">
          <div class="comtit_t">解决方案</div>
          <div class="comtit_f fix">
            <div class="comtit_f_fl fl">The Solution</div>
            <div class="comtit_f_fr fr" @click="toStrategy">MORE>></div>
          </div>
        </div>
        <div class="travels">
          <div class="travels_item">
            <ul class="fix">
              <li
                v-for="(item, index) in tourismStrategyList"
                :key="index"
                @click="toStrategyDetails(item.tourismStrategyId)"
              >
                <img :src="item.imgurl" alt="" />
                <div>
                  <p>
                    {{ item.summary }}
                  </p>
                </div>
              </li>
            </ul>
          </div>
          <div class="travels_gg" v-if="guanggao.adImg">
            <img
              :src="guanggao.adImg"
              @click="toadUrl(guanggao.adUrl)"
              alt=""
            />
          </div>
        </div>
      </div>

      <!-- 新闻资讯 -->
      <div>
        <div class="comtit">
          <div class="comtit_t">新闻资讯</div>
          <div class="comtit_f fix">
            <div class="comtit_f_fl fl">News and information</div>
            <div class="comtit_f_fr fr" @click="toNews">MORE>></div>
          </div>
        </div>
        <div class="news fix">
          <div class="news_fl fl">
            <el-carousel trigger="click" height="295px">
              <el-carousel-item
                v-for="(item, index) in NewsbannerList"
                :key="index"
              >
                <img
                  style="width: 100%; height: 100%"
                  :src="item.picUrl"
                  alt=""
                />
                <h3 class="titles">{{ item.title }}</h3>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="news_fr fr">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane
                v-for="(item, index) in newsTitList"
                :key="index"
                :label="item.classifyName"
                :name="item.newsClassifyId"
              >
                <div
                  class="news_item fix"
                  v-for="(items, indexs) in newsList"
                  :key="indexs"
                  @click="toNewPages(items)"
                >
                  <div v-if="items.isShow === '1'">
                    <div class="news_item_fl fl">
                      {{ items.createTime }}
                    </div>
                    <div class="news_item_fr fl">
                      {{ items.infoTitle }}
                    </div>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
      <!-- banner -->
      <!-- <div class="link fix">
        <div class="link_fl fl" @click="toHotel">
          <img src="@/assets/in09.jpg" alt="" />
        </div>
        <div class="link_fl fr" @click="toSpecialty">
          <img src="@/assets/in10.jpg" alt="" />
        </div>
      </div> -->
      <!-- 天气 -->
      <div class="weather">
        <ul class="fix">
          <li v-for="(item, index) in weatherList" :key="index">
            <div class="w_t fix lan">
              <span class="fl">
                {{ item.day }}
              </span>
              <!-- <span class="fr">
                今天
              </span> -->
            </div>
            <div class="w_c">
              <img
                v-if="item.wea_img === 'bingbao'"
                src="@/assets/bingbao.png"
                alt=""
              />
              <img
                v-if="item.wea_img === 'lei'"
                src="@/assets/lei.png"
                alt=""
              />
              <img
                v-if="item.wea_img === 'qing'"
                src="@/assets/qing.png"
                alt=""
              />
              <img
                v-if="item.wea_img === 'shachen'"
                src="@/assets/shachen.png"
                alt=""
              />
              <img v-if="item.wea_img === 'wu'" src="@/assets/wu.png" alt="" />
              <img
                v-if="item.wea_img === 'xue'"
                src="@/assets/xue.png"
                alt=""
              />
              <img
                v-if="item.wea_img === 'yin'"
                src="@/assets/yin.png"
                alt=""
              />
              <img v-if="item.wea_img === 'yu'" src="@/assets/yu.png" alt="" />
              <img
                v-if="item.wea_img === 'yun'"
                src="@/assets/yun.png"
                alt=""
              />
              <p>{{ item.wea }}</p>
            </div>
            <div class="w_f">
              <span class="lan">{{ item.tem2 }}</span>
              <span>~</span>
              <span class="hong">{{ item.tem1 }}</span>
              <span>℃</span>
            </div>
          </li>
        </ul>
      </div>
      <!-- 实时人数 -->
      <!-- <div class="penum">
        <ul class="fix">
          <li>
            {{ jqTouristsInfo.currentTouristsNumbers }}
            <p>实时游客</p>
          </li>
          <li>
            {{ jqTouristsInfo.touristsTotal }}
            <p>累计游客</p>
          </li>
          <li>
            {{ jqTouristsInfo.todayMaxTouritsNumbers }}
            <p>日承载量</p>
          </li>
          <li  class="ss">
            <span v-if="jqTouristsInfo.comfortIndex === '1'">舒适</span>
            <span v-if="jqTouristsInfo.comfortIndex === '2'">较舒适</span>
            <span v-if="jqTouristsInfo.comfortIndex === '3'">一般</span>
            <span v-if="jqTouristsInfo.comfortIndex === '4'">较拥挤</span>
            <span v-if="jqTouristsInfo.comfortIndex === '5'">拥挤</span>
            <p>游览舒适度</p>
          </li>
        </ul>
      </div> -->
    </div>
  </div>
</template>

<script>
import vueSeamlessScroll from 'vue-seamless-scroll'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

import './swiper/swiper.css'
export default {
  components: {
    swiper,
    swiperSlide,
    vueSeamlessScroll
  },
  data () {
    return {
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 30,
        // 显示分页
        pagination: {
          el: '.swiper-pagination',
          clickable: true // 允许分页点击跳转
        }
      },
      companyInfo: {},
      newsTitList: [
        {
          newsClassifyId: ''
        }
      ],
      todayWeather: {},
      weatherList: [
        {
          wea_img: ''
        }
      ],
      activeName: '',
      bannerList: [],
      newsList: [],
      newsBannerList: {},
      notice: [],
      url: '',
      scenicList: [],
      tourismStrategyList: [],
      jqTouristsInfo: {},
      guanggao: {},
      NewsbannerList: [],
      content: '',
      navlist: []
    }
  },
  computed: {
    classOptions () {
      return {
        step: 0.5, // 数值越大速度滚动越快
        limitMoveNum: 1, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 2, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 2000 // 单步运动停止的时间(默认值1000ms)
      }
    }
  },
  created () {
    // 游记攻略
    this.request({
      url: '/oapi/cms/tourismStrategyList',
      method: 'get',
      data: {}
    }).then((res) => {
      this.tourismStrategyList = res.data.content
      this.tourismStrategyList = this.tourismStrategyList.slice(0, 3)
    })
    this.url = process.env.BASE_URLS
    this.getInfo()
    this.getNewsBanner()
    this.getnav()
    this.request({
      url: '/oapi/cms/newsClassifyList',
      method: 'get',
      data: {}
    }).then((res) => {
      this.getNewsList(res.data.content[0].newsClassifyId)
      this.getNewsTop(res.data.content[0].newsClassifyId)
    })
    // 景区信息
    this.request({
      url: '/oapi/cms/companySimpleInfo',
      method: 'get',
      data: {}
    }).then((res) => {
      this.companyInfo = res.data.content
    })
    // 景点信息
    this.request({
      url: '/oapi/cms/scenicList',
      method: 'get',
      data: {}
    }).then((res) => {
      this.scenicList = res.data.content
      /* eslint-disable */
      	// 根据序号排序
						 this.scenicList.sort((a, b) => {
						          return a.dataSort - b.dataSort
						 })
    })
    // 景区实时人数
    this.request({
      url: '/oapi/cms/jqTouristsInfo',
      method: 'get',
      data: {}
    }).then((res) => {
      this.jqTouristsInfo = res.data.content
    })
    // 最新公告
    this.request({
      url: '/oapi/cms/latestNotice',
      method: 'get',
      data: {}
    }).then((res) => {
      // this.notice.push(res.data.content.infoContent)
      this.$set(this.notice, 0, res.data.content.infoIntroduction)
      this.content = res.data.content.infoIntroduction
    })
    // 广告
    this.request({
      url: '/oapi/cms/advertisingInfoList',
      method: 'get',
      data: {}
    }).then((res) => {
      this.guanggao = res.data.content[0]
    })
  },

  mounted () {},
  methods: {
    //获取导航信息
      getnav () {
      this.request({
        url: '/oapi/cms/categorys?pageNum=1&pageSize=100&orderByColumn=sort&isAsc=asc',
        method: 'get',
        params: {}
      }).then((res) => {

        this.navlist = res.data.content
       
      })
    },
    // 跳转景区公告
    noticeSpot () {
      this.$router.push('/scenicSpot')
    },
    toadUrl (url) {
      // if (url) {
      //   window.open(url)
      // }
      this.$router.push('/couponCenter')
    },
    tojunpUrl (url) {
      if (url) {
        window.open(url)
      }
    },
    tojdxq (scenicId) {
      // this.$router.push({
      //   path: '/introduce/details',
      //   query: { scenicId: scenicId }
      // })
        this.$router.push({
        path: '/introduce/details',
        query: { scenicId: scenicId,background: this.navlist[0].bgImg }
      })
    },
    toSpecialty () {
      // this.$router.push('/specialty')
         this.$router.push({
        path: '/specialty',
        query: { background: this.navlist[3].bgImg }
      })
    },
    toHotel () {
      // this.$router.push('/hotel')
         this.$router.push({
        path: '/hotel',
        query: { background: this.navlist[2].bgImg }
      })
    },
    toNewPages (item) {
      this.$router.push({
        path: '/news/details',
        query: { newsInformationId: item.newsInformationId,background:this.navlist[4].bgImg }
      })
    },
    toNews () {
      // this.$router.push({path: '/news', query: {background: this.back}})
       this.$router.push({
        path: '/news',
        query: { background: this.navlist[4].bgImg }
      })

    },
    toIntroduce () {
      // this.$router.push('/introduce')
        this.$router.push({
        path: '/introduce',
        query: { background: this.navlist[0].bgImg }
      })
    },
    toStrategyDetails (tourismStrategyId) {
      console.log(this.navlist);
      this.$router.push({
        path: '/strategy/details',
        query: { tourismStrategyId: tourismStrategyId,background: this.navlist[0].bgImg }
      })
    },
    toStrategy () {
      // this.$router.push('/strategy')
       this.$router.push({
        path: '/strategy',
        query: { background: this.navlist[0].bgImg }
      })
    },
    toTickets () {
  
        this.$router.push({
        path: '/tickets',
        query: { background: this.navlist[1].bgImg }
      })
      // this.$router.push('/tickets')
    },
    getInfo () {
      // 轮播图
      this.request({
        url: '/oapi/cms/rotation',
        method: 'get',
        params: {
          type: 'index'
        }
      }).then((res) => {
        this.bannerList = res.data.content
      })
      // 天气接口
      this.request({
        url: '/oapi/cms/weather',
        method: 'get',
        data: {}
      }).then((res) => {
        this.weatherList = res.data.content.data
        this.todayWeather = res.data.content
      })
      // 新闻资讯类别
      this.request({
        url: '/oapi/cms/newsClassifyList',
        method: 'get',
        data: {}
      }).then((res) => {
        this.newsTitList = res.data.content
        this.activeName = this.newsTitList[0].newsClassifyId
      })
    },
    handleClick () {
      this.getNewsList(this.activeName)
      this.getNewsTop(this.activeName)
    },
    // 新闻资讯列表
    getNewsList (newsClassifyId) {
      this.request({
        url: '/oapi/cms/newsInformationList',
        method: 'get',
        params: {
          newsClassifyId: newsClassifyId
        }
      }).then((res) => {
        // this.newsList = res.data.content.splice(0, 6)
        this.newsList = res.data.content
        var list = []
        this.newsList.forEach((item) => {
          item.createTime = this.moment(item.createTime).format('YYYY-MM-DD')
          if (item.isShow === '1') {
            list.push(item)
          }
        })
        this.newsList = list.splice(0, 6)
      })
    },
    // 新闻资讯置顶
    getNewsTop (newsClassifyId) {
      this.request({
        url: '/oapi/cms/newsInformationTop',
        method: 'get',
        params: {
          newsClassifyId: newsClassifyId
        }
      }).then((res) => {
        if (res.data.subCode === 1000) {
          this.newsBannerList = res.data.content
        }
      })
    },
    // 新闻轮播图
    getNewsBanner () {
      this.request({
        url: '/oapi/cms/newInformationRotation',
        method: 'get'
      }).then((res) => {
        this.NewsbannerList = res.data.content
      })
    }
  }
}
</script>
<style lang="less" scoped>
.banner {
  height: 800px;
  //  height: 580px;
  position: relative;
  overflow-x:hidden ;
  img {
    width: 100%;
    height: auto;
  }
  .notice {
    position: absolute;
    // width: 1200px;
    width: 800px;
    height: 68px;
    background: rgba(157, 157, 157, 0.4);
    top: 100px;
    // left: 50%;
    left: 62%;
    margin-left: -600px;
    z-index: 9;
    padding: 10px;
    // border-radius: 45px;
    // padding-left: 35px;
    padding-left: 20px;
    .notice_fl {
      // width: 200px;
      width: 170px;
      height: auto;
      overflow: hidden;
      border-right: 3px solid #434343;
      font-size: 17px;
      .notice_fl_fl {
        margin-right: 15px;
      }
      .notice_fl_fr {
        line-height: 24px;
      }
      img {
        width: 45px;
        height: 40px;
      }
    }
    .notice_fr {
      width: 75%;
      line-height: 50px;
      img {
        vertical-align: middle;
      }
      .notice_fr_fr {
        // width: 94%;
        width: 90%;
        font-size: 24px;
        color: #ff0000;
        margin-left: 20px;
        overflow: hidden;
      }
    }
  }
}
.comtit {
  height: 140px;
  color: #ce0000;
  padding-top: 50px;
  .comtit_t {
    font-size: 22px;
    font-weight: bold;
    position: relative;
    &::after {
      position: absolute;
      content: "";
      height: 2px;
      width: 92%;
      right: 0;
      background: #ce0000;
      top: 15px;
    }
  }
  .comtit_f {
    line-height: 35px;
    .comtit_f_fl {
      font-size: 14px;
    }
    .comtit_f_fr {
      font-size: 16px;
      cursor: pointer;
    }
  }
}
.introduce {
  .introduce_top {
    cursor: pointer;
    img {
      width: 100%;
      height: 388px;
    }
  }
  .introduce_top_f {
    background: #eeeeee;
    height: 100px;
    font-size: 19px;
    padding: 20px;
    text-indent: 2em;
    overflow: hidden;
    div {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
  }
  .introduce_item {
    margin-top: 40px;
    .item_li {
      float: left;
      width: 372px;
      margin-right: 42px;
      cursor: pointer;
      &:last-child {
        margin-right: 0;
      }
      img {
        width: 100%;
        height: 285px;
      }
      p {
        background: #eeeeee;
        font-size: 18px;
        padding: 0 10px;
        line-height: 70px;
        height: 70px;
        text-align: center;
      }
    }
  }
  .introduce_gg {
    margin-top: 40px;
    cursor: pointer;
    img {
      width: 100%;
    }
  }
}
.seamless-warp {
  width: 100%;
  height: 50px;
  overflow: hidden;
  font-size: 19px;

  /deep/div {
    width: 1200px !important;
  }
}
.travels {
  ul {
    li {
      float: left;
      width: 364px;
      margin-right: 54px;
      cursor: pointer;
      &:last-child {
        margin-right: 0;
      }
      img {
        width: 364px;
        height: 204px;
      }
      div {
        height: 95px;
        background: #eeeeee;
        font-size: 18px;
        padding: 10px;
        p {
          text-indent: 2em;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
        }
      }
    }
  }
  .travels_gg {
    margin-top: 58px;
    cursor: pointer;
    img {
      width: 100%;
      height: 160px;
    }
  }
}
.news {
  .news_fl {
    width: 526px;
    overflow: hidden;
    .titles {
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 9;
      width: 100%;
      height: 56px;
      background: rgba(0, 0, 0, 0.46);
      color: #fff;
      font-size: 24px;
      line-height: 56px;
      padding-left: 10px;
      font-weight: normal;
    }
    /deep/.el-carousel__indicators--horizontal {
      left: 78%;
      transform: translateX(0);
    }
  }

  .news_fr {
    width: 650px;
    height: 300px;
    overflow-y: hidden;
    /deep/.el-tabs__item {
      font-size: 24px;
      height: 50px;
      line-height: 50px;
    }
    /deep/.el-tabs__item.is-active {
      color: #ce0000;
    }
    /deep/.el-tabs__active-bar {
      background-color: #ce0000;
    }
    /deep/.el-tabs__item:hover {
      color: #ce0000;
    }
    .news_item {
      line-height: 48px;
      padding-left: 15px;
      cursor: pointer;
      .news_item_fl {
        font-size: 18px;
        color: #8d8d8d;
        margin-right: 25px;
      }
      .news_item_fr {
        font-size: 18px;
        width: 420px;
        overflow: hidden; //超出的文本隐藏
        text-overflow: ellipsis; //溢出用省略号显示
        white-space: nowrap; //溢出不换行
      }
    }
  }
}
.link {
  margin-top: 78px;
  position: relative;
  height: auto;
  overflow: hidden;
  &::after {
    position: absolute;
    content: "";
    width: 2px;
    height: 160px;
    background: #ce0000;
    left: 50%;
    top: 0;
  }
  div {
    cursor: pointer;
  }
}
.weather {
  margin-top: 77px;
  border-left: 1px solid #f5f5f5;
  border-bottom: 1px solid #f5f5f5;
  ul {
    li {
      float: left;
      width: 14.28%;
      height: 233px;
      border-right: 1px solid #f5f5f5;
      .w_t {
        height: 48px;
        background: #f5f5f5;
        line-height: 48px;
        padding: 0 20px;
        font-size: 18px;
      }
      .w_c {
        text-align: center;
        padding-top: 20px;
        font-size: 18px;
        p {
          margin-top: 40px;
        }
        img {
          width: auto;
          height: 48px;
        }
      }
      .w_f {
        text-align: center;
        font-size: 18px;
        margin-top: 10px;
      }
      .lan {
        color: #5399fd;
      }
      .hong {
        color: #eb1e27;
      }
    }
  }
}
.penum {
  height: 136px;
  border: 1px solid #ca9152;
  margin-top: 46px;
  border-radius: 20px;
  padding: 30px 0;
  ul {
    li {
      float: left;
      width: 25%;
      text-align: center;
      border-right: 1px solid #ca9152;
      height: 74px;
      font-size: 42px;
      color: #ca9152;
      line-height: 40px;
      p {
        font-size: 16px;
        color: #000;
      }
      &:last-child {
        border-right: 0;
      }
    }
  }
}
//通知公告滚动
.animate {
  padding-left: 400px;
  display: inline-block;
  white-space: nowrap;
  animation: 50s wordsLoop linear infinite normal;
}

@keyframes wordsLoop {
  0% {
    transform: translateX(100px);
    -webkit-transform: translateX(100px);
  }

  100% {
    transform: translateX(-80%);
    -webkit-transform: translateX(-100%);
  }
}

@-webkit-keyframes wordsLoop {
  0% {
    transform: translateX(100px);
    -webkit-transform: translateX(100px);
  }

  100% {
    transform: translateX(-80%);
    -webkit-transform: translateX(-100%);
  }
}
.ss{
  font-size: 33px!important;
}
/deep/.el-carousel--horizontal{
  overflow-x: initial!important;
}
#app{
  overflow-x: hidden;
}

@media screen and (max-width:1366px){
  .banner{
    height: 570px;
    overflow: hidden;
  }
  // /deep/.el-carousel__container{
  //      height: 590px!important;
  // }
}

@media (resolution: 150dpi) { 
   .banner{
    height: 600px;
    overflow: hidden;
  }
} 

@media screen and (max-width:1440px){
  .banner{
    height: 570px;
    overflow: hidden;
  }
  // /deep/.el-carousel__container{
  //      height: 590px!important;
  // }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue